"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertApiError = exports.convertExecutionApiError = exports.isApiResponseError = void 0;
var tslib_1 = require("tslib");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var includes_1 = tslib_1.__importDefault(require("lodash/includes"));
var isString_1 = tslib_1.__importDefault(require("lodash/isString"));
var http_status_codes_1 = require("http-status-codes");
function isApiResponseError(error) {
    return error.response !== undefined;
}
exports.isApiResponseError = isApiResponseError;
function getJSONFromText(data) {
    try {
        return JSON.parse(data);
    }
    catch (e) {
        return null;
    }
}
function isComplainingAboutAuthorization(error) {
    // execution on protected data will actually return with 400 + with error messaging talking about this
    var _a, _b, _c;
    if (error.response.status !== http_status_codes_1.StatusCodes.BAD_REQUEST) {
        return false;
    }
    var message = (_c = (_b = (_a = getJSONFromText(error.responseBody)) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "";
    return (includes_1.default(message, "Attempt to execute protected report unsafely") ||
        includes_1.default(message, "Export to required format is not allowed for data flagged as restricted"));
}
function convertExecutionApiError(error) {
    if (isApiResponseError(error)) {
        if (error.response.status === http_status_codes_1.StatusCodes.NO_CONTENT) {
            return new sdk_backend_spi_1.NoDataError("Server returned no data");
        }
        else if (error.response.status === http_status_codes_1.StatusCodes.REQUEST_TOO_LONG) {
            return new sdk_backend_spi_1.DataTooLargeError("Server has reached data size limits when processing this request", error);
        }
        else if (isComplainingAboutAuthorization(error)) {
            return new sdk_backend_spi_1.ProtectedDataError("Request not authorized", error);
        }
    }
    return convertApiError(error);
}
exports.convertExecutionApiError = convertExecutionApiError;
function convertApiError(error) {
    if (sdk_backend_spi_1.isAnalyticalBackendError(error)) {
        return error;
    }
    if (isApiResponseError(error)) {
        if (error.response.status === http_status_codes_1.StatusCodes.UNAUTHORIZED) {
            // detect expired passwords using the specific exception code from the backend
            // use responseBody directly (instead of response.json) in case the stream has already been used
            // at this point (which would bomb)
            var reason = isString_1.default(error.responseBody) && includes_1.default(error.responseBody, "gdc.login.password.expired")
                ? "credentials_expired"
                : "invalid_credentials";
            return new sdk_backend_spi_1.NotAuthenticated("Not authenticated against backend", error, reason);
        }
        else if (isComplainingAboutAuthorization(error)) {
            return new sdk_backend_spi_1.ProtectedDataError("Request not authorized", error);
        }
        return new sdk_backend_spi_1.UnexpectedResponseError(error.message, error.response.status, error.responseBody, error);
    }
    return new sdk_backend_spi_1.UnexpectedError("An unexpected error has occurred", error);
}
exports.convertApiError = convertApiError;
//# sourceMappingURL=errorHandling.js.map